//EqualValue validation for two input fields

import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';

export function equalValueValidator(targetKey: string, toMatchKey: string, displayName: string, userId: string): ValidatorFn {


    return (group: FormGroup): { [key: string]: any } => {
        const target = group.controls[targetKey];
        const toMatch = group.controls[toMatchKey];
        if (displayName != undefined || displayName != null) {
            displayName = displayName.replace('*', '');
        }
        //if (target.valid) {
        //    //var message = "Invalid password";
        //    var isFirstNameValid = containsSequences(displayName, target.value);
        //    if (isFirstNameValid) {
        //        target.setErrors({ equalValue: targetKey });
        //        const message = targetKey + ' != ' + toMatchKey;
        //        //console.log('target-fn: ' + target.valid); 
        //        return { 'equalValue': message };
        //    }
        //    var isUserIdValid = containsSequences(userId, target.value);
        //    if (isUserIdValid) {
        //        target.setErrors({ equalValue: targetKey });
        //        const message = targetKey + ' != ' + toMatchKey;
        //        //console.log('target-id: ' + target.valid);
        //        return { 'equalValue': message };
        //    }
        //}
        //if (toMatch.valid ) {
        //    //message = "Invalid confirm password";
        //    var isFirstNameValidtm = containsSequences(firstName, toMatch.value, 3);
        //    if (isFirstNameValidtm) {
        //        toMatch.setErrors({ equalValue: toMatchKey });
        //        const message = targetKey + ' != ' + toMatchKey;
        //        //console.log('toMatch-fn: ' + toMatch.valid);
        //        return { 'equalValue': message };
        //    }
        //    var isLastNameValidtm = containsSequences(lastName, toMatch.value, 3);
        //    if (isLastNameValidtm) {
        //        toMatch.setErrors({ equalValue: toMatchKey });
        //        const message = targetKey + ' != ' + toMatchKey;
        //        //console.log('toMatch-ln: ' + toMatch.valid);
        //        return { 'equalValue': message };
        //    }
        //    var isUserIdValidtm = containsSequences(userId, toMatch.value, 2);
        //    if (isUserIdValidtm) {
        //        toMatch.setErrors({ equalValue: toMatchKey });
        //        const message = targetKey + ' != ' + toMatchKey;
        //        //console.log('toMatch-id: ' + toMatch.valid);
        //        return { 'equalValue': message };
        //    }
        //}

        if (target.touched || toMatch.touched || target.pristine || toMatch.pristine) {
            const isMatch = target.value === toMatch.value;
            // set equal value error on dirty controls
            if (!isMatch && target.valid && toMatch.valid) {
                toMatch.setErrors({ equalValue: targetKey });
                const message = targetKey + ' != ' + toMatchKey;
                return { 'equalValue': message };
            }
            if (isMatch && toMatch.hasError('equalValue')) {
                toMatch.setErrors(null);
            }
        }
        //if (target.valid) {
        //    var regexp = new RegExp(/^(?:(?=.*[a-z])(?:(?=.*\W)(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&amp;*()_+}{&quot;:;'?/&gt;.&lt;,]))).{8,}$/);

        //    var serchfind = regexp.test(target.value);
        //    if (!serchfind) {
        //        const message = targetKey + ' != ' + toMatchKey;
        //        return { 'patternMatch': message };
        //    }
        //}
        return null;
    };

  
}


export function containsSequences(userInfo: string, password: string):Boolean
{
    var contains: boolean = false;
    if (userInfo == undefined || password == undefined) {
        return false; }
    var sequences = new Array(0);
    //To added microsoft ad pwd policy
    //should not be part of username / fullname split by commas, periods, dashes or hyphens, underscores, spaces, pound signs, and tabs
    sequences =  sequences.concat(userInfo.split(","));
    sequences =  sequences.concat(userInfo.split("."));
    sequences =  sequences.concat(userInfo.split("-"));
    sequences =  sequences.concat(userInfo.split("_"));
    sequences =  sequences.concat(userInfo.split(" "));
    sequences =  sequences.concat(userInfo.split("£"));
    sequences =  sequences.concat(userInfo.split("\t"));

    sequences = sequences.filter((element, i, arr) => {
        if (arr.indexOf(element) === i) {
            return element;
        }
    });

    for (var i = 0; i < sequences.length; i++) {
        var sequenceArray = sequences[i].split(" ");
        for (var j = 0; j < sequenceArray.length; j++) {
            var sequence = sequenceArray[j];
            sequence = sequence.replace(',', '');
            sequence = sequence.replace('.', '');
            sequence = sequence.replace('-', '');
            sequence = sequence.replace('_', '');
            sequence = sequence.replace('£', '');
            sequence = sequence.replace('\t', '');
            if (sequence != null && sequence != "" && sequence.length > 2) {
                const re1 = new RegExp(sequence, "ig");
                //console.log(sequences[j] + ":" + password + "::" + re1.test(password));
                if (re1.test(password)) {
                    contains = true;
                    break;
                }
            }
        }
        if (contains)
            break;
    }

    return contains;
}

export function uniqueDigitValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value && control.value.length == 4) {
            if (!Number.isNaN(control.value)) {
                let pin = String(control.value);
                let uniq = "";
                for (let i = 0; i < pin.length; i++) {
                    // Checking if the uniq contains the character
                    if (uniq.includes(pin[i]) === false) {
                        // If the character not present in uniq
                        // Concatenate the character with uniq
                        uniq += pin[i]
                    }
                }
                let length = uniq.length;
                if (length < 3) {
                    return { 'invalidUniqueValidator': true }
                }

                //let pin = control.value as number;
                //let res = 0;
                //let cnt = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                //while (pin > 0) {
                //    let rem = pin % 10;
                //    cnt[rem]++;
                //    pin = Math.floor(pin / 10);
                //}
                //for (let i = 0; i < 10; i++) {
                //    if (cnt[i] == 1) {
                //        res++;
                //    }
                //}
                //if (res < 2) {
                //    return { 'invalidUniqueValidator': true }
                //}
            }
            

        }

        return null;
    }
}

export function lengthCheckValidator(length: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value) {
            //let value = control.value as number;
            if (control.value.length() < length || control.value.length() > length) {
                return { 'invalidLengthValidator': true }
            }

        }

        return null;
    }
}

export function containSequenceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {

        if (control.value && control.value.length == 4) {
            let value = Number(control.value);
            if (!Number.isNaN(value)) {
                var numbers = "0123456789";
                //If reverse sequence is also needed to be checked
                var numbersRev = "9876543210";
                //Returns false, if the number is in sequence
                if (numbers.indexOf(String(value)) !== -1 || numbersRev.indexOf(String(value)) !== -1) {
                    return { 'invalidSequenceValidator': true }
                }
            }
        }
        return null;
    }
}

export function isNanValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {

        if (control.value) {
            let value = control.value as number;
            if (typeof value !== 'number') {
                return { 'isNanValidator': true }
            }
        }
        return null;
    }
}


